import Axios from 'axios'
import requestConfig from '../config/request'
const { baseURL,timeout,withCredentials } = requestConfig
import global from '@/components/global'
const axios = Axios.create({
  baseURL,
  timeout,
  headers: {
    'Content-Type':'application/json'
  },
  withCredentials
})

// 请求拦截器
axios.interceptors.request.use(config => {
  // 携带openId
  if(config.openId){
    const paramsKey = {
      'post': 'data',
      'get': 'params'
    }[config.method]
    config[paramsKey].openId = sessionStorage.getItem("openId")
  }
  return config
}, err => {
  return Promise.reject(err || '请求失败')
})

// 响应拦截器
axios.interceptors.response.use(response => {
    const {status, data} = response
    if (status === 200) {
      if (data.code === '10002' || data.code === 10002) {
        // 登录状失效,跳转登录鉴权
        window.location.href = global.doMain + "/index/v1/base/index?from=" + encodeURIComponent(window.location.href);
      }else{
        return Promise.resolve(data)
      }
    } else {
      return Promise.reject(response)
    }
  }, error => {
    return Promise.reject(error.message && error.message.includes('timeout') ? '超时请求' : error.message)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/services/request.js